import {
    BACKEND,
    apiEndpoint,
} from '../utils/api';

const backendEndpoint = apiEndpoint({
    api: BACKEND,
    endpoint: 'job',
});

export async function getRelatedJobInfo(id) {
    return backendEndpoint.get(`related/${id}`); // integer array
}

// - array of job items from supplied array of job ids
export async function getJobsById(ids) {
    return backendEndpoint.get('multiple', { params: { ids } }); // integer array
}
